const activeTabClass = 'active';

const $ = jQuery.noConflict();

function toggleTab() {
	$('.block-vertical-slider__tab-content-title').on('click', function () {
		if (!$(this).parent().hasClass(activeTabClass)) {
			$('.block-vertical-slider__tab-content-title')
				.parent()
				.removeClass(activeTabClass);
			$(this).parent().addClass(activeTabClass);
			$('.block-vertical-slider__tab-content-description').slideUp(500);
			$(this)
				.siblings('.block-vertical-slider__tab-content-description')
				.slideDown(500);
			// eslint-disable-next-line prefer-const
			let buttonId = $(this).data('id');
			// eslint-disable-next-line prefer-const
			let activeImage = $(
				'.block-vertical-slider__image[data-id=' + buttonId + ']'
			);
			const dropDownImages = $('.block-vertical-slider__image');
			if (dropDownImages.length > 1) {
				$('.block-vertical-slider__image').removeClass(activeTabClass);
				activeImage.addClass(activeTabClass);
			}
		}
	});
}

export default toggleTab;
